// src/lib/api.js
import { getIdToken } from "./auth";

const API_BASE = import.meta.env.VITE_API_BASE_URL;

/* ----------------------------------------
   IMAGE INFERENCE (EXISTING)
----------------------------------------- */

export async function fileToBase64(file) {
  if (typeof file === "string") return file;

  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result);
    reader.onerror = () => reject(new Error("FileReader failed"));
    reader.readAsDataURL(file);
  });
}

export async function inferImage({ imageFile, patientName }) {
  const token = await getIdToken();
  if (!token) throw new Error("Unauthorized");

  let base64;
  if (typeof imageFile === "string" && imageFile.startsWith("data:image")) {
    base64 = imageFile.split(",")[1];
  } else {
    const dataUrl = await fileToBase64(imageFile);
    base64 = dataUrl.split(",")[1];
  }

  const resp = await fetch(`${API_BASE}/infer`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: token,
    },
    body: JSON.stringify({
      image_base64: base64,
      metadata: { patientName },
    }),
  });

  if (!resp.ok) {
    const text = await resp.text();
    throw new Error(`API error ${resp.status}: ${text}`);
  }

  return resp.json();
}

/* ----------------------------------------
   VIDEO: GET PRESIGNED URL
----------------------------------------- */

export async function getPresignedVideoUrl() {
  const token = await getIdToken();
  if (!token) throw new Error("Unauthorized");

  const resp = await fetch(`${API_BASE}/video/get-upload-url`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: token,
    },
  });

  if (!resp.ok) {
    const txt = await resp.text();
    throw new Error("Failed to get upload URL: " + txt);
  }

  return resp.json(); // { uploadUrl, videoKey }
}

/* ----------------------------------------
   VIDEO: START PROCESSING JOB
----------------------------------------- */

export async function startVideoProcessing(videoKey) {
  const token = await getIdToken();

  const resp = await fetch(`${API_BASE}/video/start-job`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: token,
    },
    body: JSON.stringify({ video_key: videoKey }),
  });

  if (!resp.ok) {
    const txt = await resp.text();
    throw new Error("Failed to start job: " + txt);
  }

  return resp.json(); // { jobId }
}

/* ----------------------------------------
   VIDEO: STATUS POLLING
----------------------------------------- */

export async function getVideoJobStatus(jobId) {
  const token = await getIdToken();

  const resp = await fetch(`${API_BASE}/video/job-status?jobId=${jobId}`, {
    method: "GET",
    headers: {
      Authorization: token,
    },
  });

  if (!resp.ok) {
    const txt = await resp.text();
    throw new Error("Status error: " + txt);
  }

  return resp.json(); 
}
